/**
 * Marcador de Página — ficha 704 do sistema Acervo.
 * A ponta da barra de progresso é recortada em forma de fita de
 * marcador (clip-path), reforçando "onde você parou" além do número.
 */
export default function ReadingProgress({
  label,
  currentPage,
  totalPages,
  percent,
  className,
}) {
  const value =
    percent ?? (totalPages ? Math.round((currentPage / totalPages) * 100) : 0);
  const clamped = Math.min(100, Math.max(0, value));

  return (
    <div className={className}>
      <div className="mb-2 flex items-baseline justify-between text-xs text-graphite">
        <span>{label}</span>
        <span className="font-semibold text-ink tabular-nums">
          {totalPages
            ? `página ${currentPage} de ${totalPages}`
            : `${clamped}%`}
        </span>
      </div>

      <div className="relative h-1.5 rounded-full bg-parchment">
        <div
          className="h-full rounded-full bg-wine transition-[width] duration-500 ease-out"
          style={{ width: `${clamped}%` }}
        />
        <div
          className="absolute top-[-14px] h-[22px] w-[14px] bg-wine transition-[left] duration-500 ease-out"
          style={{
            left: `${clamped}%`,
            transform: 'translateX(-7px)',
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 76%, 0 100%)',
          }}
          aria-hidden="true"
        />
      </div>
    </div>
  );
}
